import React from 'react';
import Navbar from '../components/Navbar/Navbar';

const AdminLayout = ({ children }) => {
  return (
    <>
      <Navbar />
      {children}
    </>
  );
};

export default React.memo(AdminLayout);
